import { c as _c } from "react/compiler-runtime";
type PaperLetterheadProps = {
  kicker: string;
  meta: {
    label: string;
    value: string;
  }[];
  tenantLogoSrc?: string;
  tenantName?: string;
  title: string;
};
const PaperLetterhead = t0 => {
  const $ = _c(19);
  const {
    kicker,
    meta,
    tenantLogoSrc,
    tenantName,
    title
  } = t0;
  let t1;
  if ($[0] !== tenantLogoSrc || $[1] !== tenantName) {
    t1 = (tenantLogoSrc || tenantName) && <div className="flex items-center justify-between gap-4">{tenantLogoSrc ? <img src={tenantLogoSrc} alt={tenantName ?? ""} className="h-8 w-auto max-w-[240px] object-contain" /> : <p className="text-label-1 text-neutral-900">{tenantName}</p>}{tenantLogoSrc && tenantName && <p className="text-body-3 text-neutral-500">{tenantName}</p>}</div>;
    $[0] = tenantLogoSrc;
    $[1] = tenantName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== kicker) {
    t2 = <p className="text-caption-3 uppercase tracking-widest text-neutral-500">{kicker}</p>;
    $[3] = kicker;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== title) {
    t3 = <h1 className="text-heading-3 text-neutral-900">{title}</h1>;
    $[5] = title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="flex flex-col gap-1">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== meta) {
    t5 = meta.map(_temp);
    $[10] = meta;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <dl className="flex flex-col gap-1">{t5}</dl>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="border-b-2 border-neutral-900" />;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t1 || $[16] !== t4 || $[17] !== t6) {
    t8 = <header className="flex flex-col gap-5">{t1}{t4}{t6}{t7}</header>;
    $[15] = t1;
    $[16] = t4;
    $[17] = t6;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
export default PaperLetterhead;
function _temp(row) {
  return <div className="flex gap-2 text-body-3" key={row.label}><dt className="font-semibold text-neutral-900">{row.label}:</dt><dd className="text-neutral-700">{row.value}</dd></div>;
}